import moment from 'moment';
import { DateFormats } from 'constants/common';
import { DealActivityStatus } from '@trnsact/trnsact-shared-types';

import { ListingFiltersValues } from './ui/table/types';

export const INITIAL_FILTERS: ListingFiltersValues = {
  filters: {
    search: '',
    type: [],
    status: [],
    dateRange: { from: '', to: '' },
  },
};

const today = moment();

export const quickFiltersConfig: { label: string; value: Partial<ListingFiltersValues['filters']> }[] = [
  {
    label: 'All',
    value: INITIAL_FILTERS.filters,
  },
  {
    label: 'Today',
    value: {
      dateRange: {
        from: today.clone().startOf('day').format(DateFormats.ISO),
        to: today.clone().endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Tomorrow',
    value: {
      dateRange: {
        from: today.clone().add(1, 'day').startOf('day').format(DateFormats.ISO),
        to: today.clone().add(1, 'day').endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Next 30 Days',
    value: {
      dateRange: {
        from: today.clone().startOf('day').format(DateFormats.ISO),
        to: today.clone().add(30, 'days').endOf('day').format(DateFormats.ISO),
      },
    },
  },
  {
    label: 'Complete',
    value: {
      status: [DealActivityStatus.Closed],
    },
  },
];
